import React from 'react'
import { AccountIcon } from '@fourthwall/icons'

import { getColorFromText } from '../../utils/colors'
import * as S from './styled'
import { getInitialsFromName } from './utils'
import { Icon } from '../Icon'

type AvatarProps = {
  name?: string
  id?: string
  imageUrl?: string
  size?: 'small' | 'medium' | 'regular'
  hoverable?: boolean
  active?: boolean
  onClick?: () => void
}

export const Avatar = ({
  name,
  id,
  imageUrl,
  size = 'regular',
  hoverable = false,
  active = false,
  onClick,
}: AvatarProps) => {
  const as = onClick ? 'button' : 'div'

  if (imageUrl) {
    return (
      <S.Container as={as} $size={size} $hoverable={hoverable} $active={active} onClick={onClick}>
        <S.Image src={imageUrl} />
      </S.Container>
    )
  }

  if (!name) {
    return (
      <S.EmptyContainer
        as={as}
        $size={size}
        $hoverable={hoverable}
        $active={active}
        onClick={onClick}
      >
        <Icon component={AccountIcon} height={16} />
      </S.EmptyContainer>
    )
  }

  return (
    <S.Container
      as={as}
      style={{ backgroundColor: getColorFromText(id || name) }}
      $size={size}
      $hoverable={hoverable}
      $active={active}
      onClick={onClick}
    >
      <S.Initials $size={size}>{getInitialsFromName(name)}</S.Initials>
    </S.Container>
  )
}
